// 原 CSS Modules 的类名映射，去掉构建哈希以便阅读。
export default {
  chart: "TrendLines__chart",
  chartFoot: "TrendLines__chartFoot",
  chartTitle: "TrendLines__chartTitle",
  drawn: "TrendLines__drawn",
  end: "TrendLines__end",
  frame: "TrendLines__frame",
  grid: "TrendLines__grid",
  key: "TrendLines__key",
  note: "TrendLines__note",
  notes: "TrendLines__notes",
  readout: "TrendLines__readout",
  "readout-in": "TrendLines__readout-in",
  readoutLabel: "TrendLines__readoutLabel",
  readoutPanel: "TrendLines__readoutPanel",
  readoutRow: "TrendLines__readoutRow",
  readoutRule: "TrendLines__readoutRule",
  readoutSwatch: "TrendLines__readoutSwatch",
  readoutValue: "TrendLines__readoutValue",
  readoutYear: "TrendLines__readoutYear",
  svg: "TrendLines__svg",
  tick: "TrendLines__tick",
  year: "TrendLines__year",
};
